import { render, staticRenderFns } from "./Citations.vue?vue&type=template&id=3c31bd61&scoped=true&"
import script from "./Citations.vue?vue&type=script&lang=js&"
export * from "./Citations.vue?vue&type=script&lang=js&"
import style0 from "./Citations.vue?vue&type=style&index=0&id=3c31bd61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31bd61",
  null
  
)

export default component.exports